import React from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
export function ClaimProcessSection() {
  return <section className="bg-white p-8 rounded-xl border-2 border-brand-yellow/20" data-id="element-965">
      <div className="flex items-start mb-6" data-id="element-966">
        <FileText className="h-8 w-8 text-brand-yellow mr-4 mt-1" data-id="element-967" />
        <div data-id="element-968">
          <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-969">
            How to File a Claim
          </h2>
          <div className="prose text-gray-600" data-id="element-970">
            <ol className="list-decimal pl-5 space-y-2" data-id="element-971">
              <li data-id="element-972">Locate your proof of purchase (invoice or receipt).</li>
              <li data-id="element-973">Take photos of the issue if applicable.</li>
              <li data-id="element-974">Contact our support team via the contact form or phone.</li>
              <li data-id="element-975">
                We will troubleshoot the issue and provide an RMA or replacement
                part if covered.
              </li>
            </ol>
          </div>
          <div className="mt-8" data-id="element-976">
            <Link to="/contact" className="text-brand-yellow font-bold hover:underline" data-id="element-977">
              Contact Support Team →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}